class Toast extends HTMLElement {
  dismissTimer = null;
  boundClose = null;

  connectedCallback() {
    this.boundClose = () => this.close();
    this.querySelector('#toast-close')?.addEventListener('click', this.boundClose);
  }

  disconnectedCallback() {
    clearTimeout(this.dismissTimer);
    this.dismissTimer = null;
    this.querySelector('#toast-close')?.removeEventListener('click', this.boundClose);
  }

  open(title = null, content = null, autoDismissMs = 7000) {
    if (title) {
      const titleEl = this.querySelector('#toast-message-title');
      if (titleEl) {
        titleEl.textContent = title;
      }
    }

    if (content) {
      const contentEl = this.querySelector('#toast-message-content');
      if (contentEl) {
        contentEl.textContent = content;
      }
    }

    this.setAttribute('open', '');
    clearTimeout(this.dismissTimer);
    if (autoDismissMs > 0) {
      this.dismissTimer = setTimeout(() => this.close(), autoDismissMs);
    }
  }

  close() {
    this.removeAttribute('open');
    clearTimeout(this.dismissTimer);
    this.dismissTimer = null;
  }
}

if (!customElements.get('toast-message')) {
  customElements.define('toast-message', Toast);
}
